<template>
  <div>
    <v-layout class="text-xs-left ml-2 mr-2 mt-1">
      <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
        <v-avatar>
        <v-icon :color="ui.colorWarning"> {{defineDocumentFromTag(this.tag).icon}} </v-icon>
        </v-avatar>
        <span :class="ui.textWarning">
          {{defineDocumentFromTag(this.tag).title}}
        </span>
      </v-chip>
      <v-spacer/>
      <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
        <span :class="ui.textWarning">
          {{displayDocumentIDGTypeA(getDetailBasic.tag, getDetailBasic.idg)}}
        </span>
      </v-chip>
    </v-layout>
    <v-layout class="text-xs-left ml-2 mr-2">
      <v-spacer/>
      <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
        {{this.getDetailBasic.title}}
      </v-chip>
    </v-layout>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import { mapGetters } from "vuex";

export default {
  mixins: [apptheme, numberFunctions, describeDocument, displayFunctions],
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getDetailBasic"]),
    tag() {
      return this.getDetailBasic.tag;
    }
  }
};
</script>
